import React, { useEffect, useState } from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Chip from "@material-ui/core/Chip";
import { CloudUpload } from "@material-ui/icons";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Table,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  TableBody,
  makeStyles,
  CircularProgress,
} from "@material-ui/core";

import SpanPanel from "./spanPanel";
import { formatDate } from "../../../utils/DateUtil";
import {
  renderOptions,
  getValuePlain,
  valueToName,
  getAge,
  iconsFile,
  handleDownload,
} from "../../../utils/FormUtil";
import { gender_pet, size_pet } from "../../../constants/constants";
import { SearchPreexistingDiseases } from "../../../services/patientService";
import { useStateAuthValue } from "../../../context/Auth/AuthState";
import {
  GetMedicalStudiesOnlyNames,
  GetMedicalStudyById,
  GetSanitariesRecordOnlyNames,
  GetSanitaryRecordById,
} from "../../../services/petService";
import { showToast, ToastType } from "../../../utils/ToastUtil";
import { useToast } from "../../../context/Toast/ToastProvider";

const useStyles = makeStyles((theme) => ({
  dataWrapper: {
    // Add any existing styles for data-wrapper
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  loadingIcon: {
    width: 20,
    height: 20,
    color: theme.palette.primary.main,
  },
}));
const PersonalData = ({ data }) => {
  const classes = useStyles();
  const [preExistingDisease, setPreExistingDisease] = useState([]);
  const [filesHealthBooklet, setFilesHealthBooklet] = useState([]);
  const [filesStudyFormat, setFilesStudyFormat] = useState([]);
  const [loadingFileId, setLoadingFileId] = useState(null);
  const toastDispatch = useToast();
  const getPatientPreExistingDiseases = async (
    userToken,
    pre_existing_disease
  ) => {
    return await SearchPreexistingDiseases(userToken, pre_existing_disease);
  };
  const [userData] = useStateAuthValue();

  const getStudies = async (petId) => {
    try {
      const response = await GetMedicalStudiesOnlyNames(
        petId,
        userData.userToken
      );

      if (response.status === 200) {
        const studies = response.data;
        setFilesStudyFormat(studies);
      }
    } catch (error) {
      return [];
    }
  };

  const getHealthBook = async (petId) => {
    try {
      const response = await GetSanitariesRecordOnlyNames(
        petId,
        userData.userToken
      );
      if (response.status === 200) {
        const healthBook = response.data;
        setFilesHealthBooklet(healthBook);
      }
    } catch (error) {
      return [];
    }
  };

  const onDownload = async (type = "studies", fileId) => {
    try {
      setLoadingFileId(fileId);
      if (type === "studies") {
        const response = await GetMedicalStudyById(fileId, userData.userToken);
        if (response.status === 200) {
          const file = response.data;
          handleDownload(file.base64, file.filename, file.mimetype);
        }
      } else {
        const response = await GetSanitaryRecordById(
          fileId,
          userData.userToken
        );
        if (response.status === 200) {
          const file = response.data;
          handleDownload(file.base64, file.filename, file.mimetype);
        }
      }
    } catch {
      showToast(
        toastDispatch,
        "Ha ocurrido un error descargando el archivo",
        ToastType.ERROR
      );
    } finally {
      setLoadingFileId(null);
    }
  };

  useEffect(() => {
    if (data) {
      getPatientPreExistingDiseases(
        userData.userToken,
        data.patient_dto.pre_existing_disease
      ).then((res) => {
        setPreExistingDisease(res);
      });
      getHealthBook(data.patient_dto.id);
      getStudies(data.patient_dto.id);
    }
  }, [data]);

  return (
    <>
      <div>
        <Accordion className="accordion-history-clinic">
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className="header-accordion">
              Datos de la Mascota
            </Typography>
          </AccordionSummary>
          <AccordionDetails className="accordion-detail">
            <TableContainer>
              <Table>
                <TableHead></TableHead>
                <TableBody>
                  <TableRow className="table">
                    <TableCell
                      align="center"
                      variant="head"
                      className="table-cell"
                    >
                      <div className="detail">
                        <div className="data-wrapper">
                          {/* <SpanPanel
                            title="Correo"
                            data={getValuePlain(data?.email)}
                          ></SpanPanel>  */}
                          {/* <SpanPanel
                            title="Teléfono"
                            data={getValuePlain(data?.phone_number)}
                          ></SpanPanel> */}
                          <SpanPanel
                            title="Nombre"
                            data={getValuePlain(data?.first_name)}
                          ></SpanPanel>
                          <SpanPanel
                            title="Nombre Propietario"
                            data={getValuePlain(
                              data?.patient_dto.proprietary_name
                            )}
                          ></SpanPanel>
                          <SpanPanel
                            title="Especie"
                            data={getValuePlain(data?.species)}
                          ></SpanPanel>
                          <SpanPanel
                            title="Raza"
                            data={getValuePlain(data?.race)}
                          ></SpanPanel>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell
                      align="center"
                      variant="head"
                      className="table-cell"
                    >
                      <div className="detail">
                        <div className="data-wrapper">
                          <SpanPanel
                            title="Edad"
                            data={data?.birth_date && getAge(data?.birth_date)}
                          ></SpanPanel>
                          <SpanPanel
                            title="Color de Pelaje"
                            data={getValuePlain(data?.furColor)}
                          ></SpanPanel>
                          <SpanPanel
                            title="Castrado"
                            data={data?.castrated ? "SI" : "NO"}
                          ></SpanPanel>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell
                      align="center"
                      variant="head"
                      className="table-cell"
                    >
                      <div className="detail">
                        <div className="data-wrapper">
                          <SpanPanel
                            title="Sexo"
                            data={
                              data?.sex_str
                                ? valueToName(gender_pet, data?.sex_str)
                                : "-"
                            }
                          ></SpanPanel>
                          <SpanPanel
                            title="Nacimiento"
                            data={formatDate(data?.birth_date)}
                          ></SpanPanel>
                          <SpanPanel
                            title="Tamaño"
                            data={
                              getValuePlain(
                                size_pet.find(
                                  (s) => s.value == data?.patient_dto?.size
                                )
                              )?.name
                            }
                          ></SpanPanel>
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>
      </div>
      <div>
        <Accordion className="accordion-history-clinic">
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className="header-accordion">Datos Medicos</Typography>
          </AccordionSummary>
          <AccordionDetails className="accordion-detail">
            <TableContainer>
              <Table>
                <TableHead></TableHead>
                <TableBody>
                  <TableRow className="table">
                    <TableCell
                      align="center"
                      variant="head"
                      className="table-cell"
                    >
                      <div className="detail">
                        <div
                          className="data-wrapper"
                          style={{ maxWidth: "20rem", width: "20rem" }}
                        >
                          <SpanPanel
                            title="Enf. preexistentes"
                            data={renderOptions(preExistingDisease)}
                          ></SpanPanel>

                          <SpanPanel
                            title="Medicación"
                            data={renderOptions(
                              data?.patient_dto?.frequent_medication
                            )}
                          ></SpanPanel>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell
                      align="center"
                      variant="head"
                      className="table-cell"
                    >
                      <div className="detail">
                        <div className="data-wrapper">
                          <SpanPanel
                            title="Cirugías"
                            data={renderOptions(data?.patient_dto?.surgeries)}
                          ></SpanPanel>
                          {/* <SpanPanel
                            title="Vacunas"
                            data={renderOptions(data?.patient_dto?.vaccines)}
                          ></SpanPanel> */}
                        </div>
                      </div>
                    </TableCell>
                    <TableCell
                      align="center"
                      variant="head"
                      className="table-cell"
                    >
                      <div className="detail">
                        <div className="data-wrapper">
                          <SpanPanel
                            title="Estudios Médicos"
                            data={
                              filesStudyFormat.length !== 0 &&
                              filesStudyFormat.map((file, index) => (
                                <div key={index} style={{ padding: "2px" }}>
                                  <Chip
                                    key={index}
                                    avatar={iconsFile(file.type)}
                                    label={file.filename}
                                    onDelete={() =>
                                      onDownload("studies", file.id)
                                    }
                                    deleteIcon={
                                      loadingFileId === file.id ? (
                                        <CircularProgress
                                          className={classes.loadingIcon}
                                          size={20}
                                        />
                                      ) : (
                                        <CloudUpload />
                                      )
                                    }
                                  />
                                </div>
                              ))
                            }
                          ></SpanPanel>
                          <SpanPanel
                            title="Libreta Sanitaria"
                            data={
                              filesHealthBooklet.length !== 0 &&
                              filesHealthBooklet.map((file, index) => (
                                <div key={index} style={{ padding: "2px" }}>
                                  <Chip
                                    key={index}
                                    avatar={iconsFile(file.type)}
                                    label={file.filename}
                                    onDelete={() =>
                                      onDownload("healthBooklet", file.id)
                                    }
                                    deleteIcon={
                                      loadingFileId === file.id ? (
                                        <CircularProgress
                                          className={classes.loadingIcon}
                                          size={20}
                                        />
                                      ) : (
                                        <CloudUpload />
                                      )
                                    }
                                  />
                                </div>
                              ))
                            }
                          ></SpanPanel>
                        </div>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  );
};

export default PersonalData;
